import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';


import {Button} from '@mui/material'

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
  avatar: {
    margin: 10,
  },
  greenAvatar: {
    margin: 10,
    color: '#fff',
    backgroundColor: 'rgba(71,237,62,1)',
  }

});

class SmartWiFi extends Component {
  state = {
    devices: [],
    url: '',
    mobileId: '',
    mac: '',
    selectDevice: false
  };

  componentDidMount() {
    this.getDevices()
  }

  componentWillUnmount(){
    console.log('unmount')
    this.props.logoutSmartWiFi(this.state.mobileId, this.state.mac)
  }


  getDevices = async (value) => {

    try {
      let devices = await this.props.getSmartWiFiDevices()
      this.setState({devices: devices})
      if (devices.length === 0) {
        // do nothing, alert is shown
      } else if (devices.length === 1) {
        this.setState({selectDevice: false})
        this.loginSmartWifi(devices[0].serialNumber)
      } else {
        this.setState({selectDevice: true})
      }
    } catch (error) {
      console.log(error)
    }
  }

  loginSmartWifi = async (serialNumber) => {
    try {
      this.setState({selectDevice: false})
      let resp = await this.props.loginSmartWiFi(serialNumber)
      // this.setState({url: "https://www.lanacion.com.ar"})
      // this.setState({url: resp.url})
      // window.open(resp.url, "_blank");
      this.setState({mobileId: resp.mobileId})
      this.setState({mac: resp.mac})
    } catch (error) {
      console.log(error)
    }
  }

  logoutSmartWifi = async () => {
    await this.props.logoutSmartWiFi(this.state.mobileId, this.state.mac)
    this.setState({url: '', serialNumber: ''})
  }

  render() {
    return (
      <div>
        < AppBar position = "static"
        style = {
          {
            marginLeft: 260,
            backgroundColor: "#55565A"
          }
        } >
          <Toolbar>
            <Typography variant="h5">
              My Smart WiFi
          </Typography>
          </Toolbar>
        </AppBar>

        <div>
        <Paper position="fixed" align="center" style={{
          marginTop: 20,
          paddingTop: 20,
          height: 600,
          //width: "100%",
          marginLeft: 300,
          marginRight: 40
        }}>
          {this.state.url !=='' ?
            <iframe src={this.state.url} title="Smart WiFi" width="95%" height="100%" ></iframe>
             : null
          }
          {this.state.selectDevice ?
          
            <div>
              <Typography variant="h6">Select a Smart WiFi device</Typography>
              {this.state.devices.map(n => {
                  return (
                    <div>
                      <Button 
                        onClick={function() {this.loginSmartWifi(n.serialNumber)}.bind(this)}
                        variant="contained" 
                        color="primary" 
                        style={
                          {
                            background: '#47ED3E',
                            fontWeight: 'bold',
                            borderRadius: 5,
                            border: 0,
                            color: '#55565A',
                            height: 40,
                            padding: '0 30px',
                            width: 200,
                            marginBottom: 0,
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            marginTop: 20
                          }}
                      >{n.serialNumber}
                      </Button>
                    </div>
                  )
              })}
            </div> : null
          }
        </Paper>

        </div>
      </div>
    )

  }
}
export default withStyles(styles)(SmartWiFi)